<style lang="scss" src="./style.scss"></style>

<template>
  <v-popover
    ref="popover"
    class="dropdown"
    v-bind="$attrs"
    :popover-class="popoverClass"
    :auto-hide="autoHide"
    :offset="offset"
    :disabled="disabled"
    v-on="$listeners"
    @update:open="onUpdateOpen"
    @keydown.native.tab="onKeyTab"
  >
    <div class="dropdown__label">
      <slot name="label" />
    </div>
    <div
      slot="popover"
      ref="popoverContent"
      class="dropdown__content"
      :class="contentClass"
      :disabled="!isOpen"
    >
      <slot />
    </div>
  </v-popover>
</template>

<script>
export default {
  name: 'VDropdown',
  inheritAttrs: false,
  props: {
    autoHide: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 4,
    },
    noPopoverFocus: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: [String, Array, Object],
      default: null,
    },
    popoverClass: {
      type: [String, Array, Object],
      default: undefined,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onKeyTab(event) {
      if (this.isOpen && !this.noPopoverFocus) {
        const el = this.$refs.popoverContent.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]'
        );
        if (el) {
          event.preventDefault();
          el.focus();
        }
      }
    },
    onUpdateOpen(value) {
      this.isOpen = value;
    },
  },
};
</script>
